import { ScdAccordionSummary } from "../../../../ui/widgets/accordion/summary";
import Typography from "../../../../ui/widgets/typography";
import { ScdAccordionDetails } from "../../../../ui/widgets/accordion/details";
import { Grid } from "@mui/material";
import InputContainer from "../../../../ui/layout/page/forms-container/form-item-container/input-container";
import FirstName from "../../../shared/components/first-name";
import LastName from "../../../shared/components/last-name";
import React, { useContext, useState } from "react";
import { CardholderFormProps } from "../types";
import { ScdAccordion } from "../../../../ui/widgets/accordion";
import get from "lodash.get";
import { CardholderFormikContext } from "../../context";
import { useMessageSource } from "react-message-source";

interface FullNameAccordionProps {
  firstName: CardholderFormProps["firstName"];
  lastName: CardholderFormProps["lastName"];
  dataPath: string;
}

export const FullNameAccordion = ({
  dataPath,
  firstName,
  lastName,
}: FullNameAccordionProps) => {
  const { errors, touched, values } = useContext(CardholderFormikContext);
  const { getMessage: t } = useMessageSource();

  const [isAccordionExpanded, setIsAccordionExpanded] = useState<boolean>(
    () => {
      const firstNameHasErrorsAndTouchedAndEmpty =
        (get(errors, `${dataPath}firstName`) &&
          get(touched, `${dataPath}firstName`)) ||
        !get(values, `${dataPath}firstName`);

      const lastNameHasErrorsAndTouchedAndEmpty =
        (get(errors, `${dataPath}lastName`) &&
          get(touched, `${dataPath}lastName`)) ||
        !get(values, `${dataPath}lastName`);

      const isAccordionExpandedFlag =
        firstNameHasErrorsAndTouchedAndEmpty ||
        lastNameHasErrorsAndTouchedAndEmpty;

      return Boolean(isAccordionExpandedFlag);
    },
  );

  const handleAccordionChange = (
    _: React.SyntheticEvent,
    isExpanded: boolean,
  ) => {
    setIsAccordionExpanded(isExpanded);
  };

  return (
    <ScdAccordion
      expanded={isAccordionExpanded}
      onChange={handleAccordionChange}
    >
      <ScdAccordionSummary>
        <Typography variant="body2">{t("FullName")}</Typography>
      </ScdAccordionSummary>
      <ScdAccordionDetails>
        <Grid className="scd-container-base" container>
          <InputContainer>
            <FirstName dataPath={dataPath} value={firstName} />
          </InputContainer>
          <InputContainer>
            <LastName dataPath={dataPath} value={lastName} />
          </InputContainer>
        </Grid>
      </ScdAccordionDetails>
    </ScdAccordion>
  );
};
